import { render, staticRenderFns } from "./ModifiedSales.vue?vue&type=template&id=6e54cbe4"
import script from "./ModifiedSales.vue?vue&type=script&lang=js"
export * from "./ModifiedSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports